import { DimensionPropertyResponse } from '@api/gateway/KnowledgePreexam-default/index'
import { getModule, Module, Action } from 'vuex-module-decorators'
import store from '@/store'
import SyllabusModuleDecorator from '../../common/syllabus/SyllabusModuleDecorator'
import SyllabusTreeMata from '@api/module/common/syllabus/model/SyllabusTreeMata'
import { ResponseStatus } from '@api/Response'
import KnowledgePreexamGateway from '@api/gateway/KnowledgePreexam-default'

@Module({ namespaced: true, dynamic: true, name: 'SyllabusModule', store })
class SyllabusModule extends SyllabusModuleDecorator {
  /**
   *@description 根据专业和考纲id搜索考纲树信息
   *@author lsh
   *@param
   *@date 2020-12-10
   */
  @Action
  async findSyllabusInfoByIdOrMajorId(query: {
    syllabusIdList?: Array<string>
    majorIdList?: Array<string>
  }): Promise<ResponseStatus> {
    //查过的就不查
    const commitSyllabusIdList = []
    for (const id of query.syllabusIdList || []) {
      //考纲id不在idList里面就推入数组
      if (!this.syllabusList.find(syllabus => syllabus.id === id)) commitSyllabusIdList.push(id)
    }
    const commitMajorIdList = []
    for (const id of query.majorIdList || []) {
      const searchItem = this.syllabusList.filter(syllabus => syllabus.major.id === id)
      //专业id不在已有idList
      let canPush = false
      if (!searchItem?.length) {
        canPush = true
        //或者
      } else {
        searchItem.forEach(item => {
          //专业id存在已有idlist 但是 存在传入的id 不属于已有的idList列表
          if ((query.syllabusIdList?.indexOf(item.id) || -1) < 0) canPush = true
        })
      }
      if (canPush) commitMajorIdList.push(id)
    }
    if (!commitSyllabusIdList.length && !commitMajorIdList.length) return Promise.resolve(new ResponseStatus(200, ''))
    const result = await KnowledgePreexamGateway.findSyllabusPageListByQuery({
      query: {
        syllabusIdList: commitSyllabusIdList,
        majorIdList: commitMajorIdList
      },
      pageNo: 1,
      pageSize: 200
    })
    this.SET_SYLLABUS_LIST(result.data.currentPageData)
    return result.status
  }

  /**
   *@description 获取所有至选取节点以下的 叶子考纲节点信息
   *@author lsh
   *@param syllabusId 考纲id
   *@param syllabusMataId 考纲元素id
   *@date 2020-12-04
   */
  get getSyllabusLeafIdsFromSelectNode() {
    return (syllabusId: string, syllabusMataId: string) => {
      const selectNode = this.getSyllabusTreeFromSelectNode(syllabusId, syllabusMataId),
        Ids: Array<string> = []
      if (!selectNode) return []

      const dfsPushId = (node: SyllabusTreeMata) => {
        if (!node?.childList.length) {
          Ids.push(node.id)
        } else {
          node.childList.forEach(child => dfsPushId(child))
        }
      }
      dfsPushId(selectNode)
      return Ids
    }
  }
}

export default getModule(SyllabusModule)
